export const footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToTopClickHandler = (e: Event) => {
    e.preventDefault();
    scrollToTop();
  };

  document.querySelectorAll("[data-js-footer=scroll-link]").forEach((link) => {
    link.addEventListener("click", scrollToTopClickHandler);
  });
};
